/**
 * Debounce util.
 */
export function debounce(callback: Function, delay: number) {
  let timeoutId;

  return function run(...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      timeoutId = null;

      callback(...args);
    }, delay);
  };
}

/**
 * Debounce animation frame util.
 */
export function debounceAnimationFrame(callback: Function) {
  let frame;

  return function run(...args) {
    if (frame) {
      cancelAnimationFrame(frame);
    }

    frame = requestAnimationFrame(() => {
      frame = null;

      callback(...args);
    });
  };
}
